import { render, staticRenderFns } from "./eveningPaperSet.vue?vue&type=template&id=5cca2ee9&scoped=true&"
import script from "./eveningPaperSet.vue?vue&type=script&lang=js&"
export * from "./eveningPaperSet.vue?vue&type=script&lang=js&"
import style0 from "./eveningPaperSet.vue?vue&type=style&index=0&id=5cca2ee9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca2ee9",
  null
  
)

export default component.exports